module.exports = __webpack_public_path__ + "img/clicksign.79227d14.svg";